import type { LicenseUsageResource } from "@octopusdeploy/octopus-server-client";
type SupportedLimits = "projects" | "tenants" | "targets" | "machines" | "users" | "tasks" | "task cap";
export const getLicenseLimit = (licenseUsage: LicenseUsageResource | null, limitName: SupportedLimits) => {
    if (!licenseUsage || !licenseUsage.Limits) {
        return {
            limitData: null,
            isLimitReached: false,
            currentUsage: 0,
            licensedLimit: 0,
            isUnlimited: false,
        };
    }
    const limitData = licenseUsage.Limits.find((limit) => limit.Name.toLowerCase() === limitName.toLowerCase()) || null;
    const isLimitReached = limitData && !limitData.IsUnlimited && limitData.CurrentUsage >= limitData.LicensedLimit;
    return {
        limitData,
        isLimitReached,
        currentUsage: limitData?.CurrentUsage || 0,
        licensedLimit: limitData?.LicensedLimit || 0,
        isUnlimited: limitData?.IsUnlimited || false,
    };
};
